import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { EmbeddedVideo } from '../components/blocks/EmbeddedVideo';

export const isEmbeddedVideo = isElementType(EmbeddedVideo);
